export default __webpack_public_path__ + "static/streamlining-sea-route-booking-with-an-iIntegrated-online-platform-59c4cdf83bcfa28bcf58672747e60023.png";